<template>
    <div v-if="machine.end_date">
        <span class="text-secondary m-2"><i>{{ $t('No settings found for this device.') }}</i></span>
    </div>
    <div v-else class="border-primary card m-2" style="width: 700px">
        <div class="bg-primary card-header d-flex flex-row justify-content-between navbar-height">
            <h2 class="flex-grow-1 text-white p-1">{{ $t('Settings') }}</h2>
            <DeviceEdit v-if="hasPermissionAdd && isConnectedPatientAllowed" :mode="'Add'" :patient_id="machine.patient_id" :history_id="machine.history_id" :edit_allowed="machine.edit_allowed" />
        </div>
        <div class="card-body">
            <div class="card">
                <div class="card-header"><h3>{{ $t('No settings found for this device.') }}</h3></div>
            </div>
        </div>
    </div>
    <DeviceSettings :settings="settings" :history_id="machine.history_id" :patient_id="machine.patient_id"
        :machine="machine" :user_org="user_org" :auth_user="auth_user" />
</template>

<script setup>
import { computed } from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";
import DeviceSettings from "./DeviceSettings.vue";
import DeviceEdit from "./DeviceEdit.vue";
import usePermissions from "@/vue/composables/usePermissions";

const props = defineProps({
    settings: {
        type: [Object, null],
        required: true,
    },
    machine: {
        type: Object,
        required: true,
    },
    user_org: {
        type: [Object, null],
        required: true,
    },
    patient_org: {
        type: Object,
        required: false,
    },
    auth_user: {
        type: [Object, null],
        required: true,
    }
});

const hasPermissionAdd = computed(() => {
    if (!props.auth_user) {
        return null;
    }
    return hasPermission(props.auth_user.can, 'update.device.settings')
})

const { hasPermission } = usePermissions();

const isConnectedPatientAllowed = computed(() => {
    let disallow_external_device_edit = props?.patient_org?.settings?.settings?.disallow_external_device_edit ?? false;
    if (disallow_external_device_edit === true && props.user_org?.id !== props.patient_org?.id) {
        return false;
    } else {
        return true;
    }
})
</script>
